import { render, staticRenderFns } from "./accidentCausePrevention.vue?vue&type=template&id=2927e059"
import script from "./accidentCausePrevention.vue?vue&type=script&lang=js"
export * from "./accidentCausePrevention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2927e059')) {
      api.createRecord('2927e059', component.options)
    } else {
      api.reload('2927e059', component.options)
    }
    module.hot.accept("./accidentCausePrevention.vue?vue&type=template&id=2927e059", function () {
      api.rerender('2927e059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/accidentCausePrevention.vue"
export default component.exports